<!--
 * @Author: etwl
 * @Date: 2021-11-09 14:49:05
 * @LastEditTime: 2022-07-19 17:13:55
 * @LastEditors: ettttt etwl@didiglobal.com
 * @FilePath: /soda-act/src/page/oldCustomer/components/taskCenter.vue
-->
<template>
    <div class="task-center_container" v-if="taskData">
        <TaskCenterHeader 
          :taskTimer="taskData.expireTime.day" 
          :ExpireShowType="taskData.expireTime.showType"
          :RemainingSeconds="taskData.expireTime.second"
          :isShowTimer="missionStatus==1"
          @get-task-init="_initData"
          />
        <TaskCenterMain 
          :activityID="taskData.activityID"
          :missionStatus="missionStatus"
          :missionProgressReward="taskData.missionProgressReward"
          :isOtherActivity="isOtherActivity"
          @handleUse="handleUse"
          @getCurrentTaskStyle="getCurrentTaskStyle"
          @getTaskOrderButtonCkData="getTaskOrderButtonCkData"
        />
        <TaskCenterFooter 
          :missionStatus="missionStatus"
          :taskOrderButtonCkData="taskOrderButtonCkData"
        />
        <CouponDialog 
          :couponDialogShow.sync="couponDialogShow"
          :couponList="couponList"
          :rewardDesc="rewardDesc"
          :positioningX="positioningX"
          :positioningY="positioningY"
          :isUseAnimation="isUseAnimation"
          @dialog-close="dialogClose"
          @TaskCouponRedenvelopeCk="TaskCouponRedenvelopeCk"
        />
    </div>
</template>
<script>
import { receiveMissionReward, getPopup } from '@/api/oldCustomer/index.js'
import TaskCenterHeader from './taskCenterHeader.vue'
import TaskCenterMain from './taskCenterMain.vue'
import TaskCenterFooter from './taskCenterFooter.vue'
import CouponDialog from './couponDialog/index.vue'
import {homepageTaskCouponRedenvelopeSw, homepageTaskCouponRedenvelopeCk, homepageTaskCouponCompleteSw} from '../trackEvent'
import {
  getScheme
} from '@/common/js/utils'
import { isEmpty } from 'lodash-es'
export default {
  name: 'TaskCenter',
  components: {
    TaskCenterHeader,
    TaskCenterMain,
    TaskCenterFooter,
    CouponDialog
  },
  props: {
    taskData: {
      default: {}
    },
    isOtherActivity: {
      default: 2
    }
  },
  data () {
    return {
      couponDialogShow: false,
      couponList: [],
      rewardDesc: '',
      positioningX: 0,
      positioningY: 0,
      ladderNum: 0,
      animation: 1030,
      taskOrderButtonCkData: {},
      countable: true,
      clickIndex: null,
      isPushMessage: false,
      isUseAnimation: true
    }
  },
  computed: {
    missionStatus () {
      if (isEmpty(this.taskData)) {
        return 2
      } else {
        return this.taskData.missionStatus
      }
    },
    isOneTask () {
      return this.taskData.missionProgressReward.length == 1 // eslint-disable-line
    },
    from(){
      return this.params.from
    }
  },
  watch: {
    '$route': function (newV) {
      const {ladderNum} = newV.query
      if (!ladderNum) {
        this.isPushMessage = false
      }
    }
  },
  created () {
    if (this.params.ladderNum == -1) { // eslint-disable-line
      this.isPushMessage = true
    }
  },
  mounted () {
    if (this.isPushMessage) {
      this.handleUse({
        ladderNum: -1
      })
    } else {
        this.automaticallyReceive()
    }
  },
  methods: {
    _initData () {
      this.$emit('_initData')
    },
    // 自动领取弹窗
    async automaticallyReceive(){
      const res = await getPopup({
         userMissionID: this.taskData.userMissionID,
      })
      const toastTime = 2000
      if (!res.errno) {
        // 领取成功的提示
        if (res.data.isSuccess) {
          this.rewardDesc = res.data.rewardDesc
          if (!isEmpty(res.data.couponList)) {
            this.couponList = res.data.couponList
            this.couponDialogShow = true
            homepageTaskCouponCompleteSw({
              activity_id: this.taskData.activityID,
              activity_type: 1
            })
            this.homepageTaskCouponRedenvelope()
          }
        }
      } else {
        // 领取失败的提示
        this.globalMsg({
          txt: res.errmsg,
          type: 'error',
          show: true,
          time: toastTime
        })
      }

      // 不要缩的动画
      this.isUseAnimation = false
    },
    async handleUse ({ladderNum, btnStatus}) {
      // 按钮的状态为2的时候，代表已经领取过了
      if (btnStatus === 2) return
      const res = await receiveMissionReward({
        ladderNum,
        userMissionID: this.taskData.userMissionID,
        activityID: this.taskData.activityID,
        isNeedRewardDetail: 1 // 是否需要奖励详情, 0或者不传表示不需要，1表示需要。 若需要会新增couponList和rewardDesc返回字段
      })

      const toastTime = 2000
      if (!res.errno) {
        // 领取成功的提示
        if (res.data.isSuccess) {
          this.rewardDesc = res.data.rewardDesc
          if (!isEmpty(res.data.couponList)) {
            this.couponList = res.data.couponList
            this.couponDialogShow = true
            if (ladderNum == -1) { // eslint-disable-line
              this.homepageTaskCouponRedenvelope()
            }
            homepageTaskCouponCompleteSw({
              activity_id: this.taskData.activityID,
              activity_type: 1
            })
          }
        } else {
          if (this.isPushMessage) {
            this.automaticallyReceive()
            return
          }
          this.globalMsg({
            txt: res.data.errMsg,
            type: 'error',
            show: true,
            time: toastTime
          })
        }
      } else {
        if (this.isPushMessage) return
        // 领取失败的提示
        this.globalMsg({
          txt: res.errmsg,
          type: 'error',
          show: true,
          time: toastTime
        })
      }
      if (!this.isPushMessage) {
        this.ladderNum = ladderNum
      }
    },
    globalMsg (config) {
      this.toast = this.$createToast({
        ...config,
        type: config.type === 'success' ? 'correct' : config.type
      })
      this.toast.show()
    },
    // 获取当前点击的进度条的位置
    getCurrentTaskStyle (index, status, ladderNum) {
      if (status === 'click') {
        // 如果点击的，获取第一次，将后面的全部剔除掉
        this.clickIndex = index
      }
      const indexes = this.clickIndex || index
      if (this.isPushMessage) {
        this.ladderNum = ladderNum
      }
      // 点击的时候一定
      this.$nextTick(() => {
        const el = document.querySelectorAll('.swiper-slide .status-icon')[indexes] || {}
        const {width = 0, height = 0, left = 0, top = 0} = (el.getBoundingClientRect && el.getBoundingClientRect()) || {}
        this.positioningX = left + width / 2
        this.positioningY = top + height / 2
      })
    },
    dialogClose () {
      this.clickIndex = null
      // 立即获取最新任务数据，所有的阶梯任务对应的icon会变，
      this.getTheStatus(true) // 所有的阶梯任务对应的icon会变，会再变一次 而且异步
      // 动画之后再请求一次服务端端数据 少时间，其他的可以优化处理 1秒之后会更新显示时间
      setTimeout(() => {
        if (this.isPushMessage) {
          const newQuery = JSON.parse(JSON.stringify(this.$route.query))
          delete newQuery.ladderNum
          this.$router.replace({
            query: newQuery
          })
        }
        this._initData()
      }, this.animation)
    },
    getTheStatus (justGetThe) {
      this.taskData.missionProgressReward = this.taskData.missionProgressReward.map(item => {
        if (item.ladderNum == this.ladderNum) { // eslint-disable-line
          item.justGetThe = justGetThe // 刚刚领取
          if (!this.isOneTask) {
          // 不是一单的时候执行
            if(item.rewardStrategy[0].buttons[0]) {
              item.rewardStrategy[0].buttons[0].status = 2
              item.rewardStrategy[0].buttons[0].text = this.$t('FoodC_C_Received_DOQd')
            }
          }
        }
        return {
          ...item
        }
      })
    },
    TaskCouponRedenvelopeCk () {
      homepageTaskCouponRedenvelopeCk({
        activity_id: this.taskData.activityID,
        coupon_info: JSON.stringify(this.couponInfo()), // {coupon_type:0平台券 1商家券,coupon_id：券id,index:天降弹窗券列表位置（从0开始）}
        activity_type: 1 // 1 订单任务 2 消费任务
      }, () => {
        location.href = `${getScheme()}://soda/homePage?closeSideMenu=1`
      })
    },
    homepageTaskCouponRedenvelope () {
      this.$nextTick(() => {
        homepageTaskCouponRedenvelopeSw({
          activity_id: this.taskData.activityID,
          coupon_info: JSON.stringify(this.couponInfo()), // {coupon_type:0平台券 1商家券,coupon_id：券id,index:天降弹窗券列表位置（从0开始）}
          activity_type: 1, // 1 订单任务 2 消费任务
          from:this.from
        })
      })
    },
    couponInfo () {
      return this.couponList.map((item, index) => {
        return {
          coupon_type: 1, // :1平台券 2商家券
          couponType: item.couponType,
          coupon_id: item.couponId,
          index
        }
      })
    },
    getTaskOrderButtonCkData (val) {
      const couponStatus = isEmpty(val.buttons) ? 3 : val.buttons[0].status
      let taskNum = 0
      if (this.taskData.missionProgressReward[0].ladderNum == -1) { // eslint-disable-line
        taskNum = this.taskData.missionProgressReward.length - 1
      } else {
        taskNum = this.taskData.missionProgressReward.length
      }
      this.taskOrderButtonCkData = {
        task_num: taskNum,
        activity_type: 1,
        coupon_id: val.couponId,
        batch_id: val.batchId,
        coupon_type: 1,
        coupon_status: couponStatus, // 券的领取状态
        activity_id: this.taskData.activityID
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.task-center_container
  width 702px
  background #FFFFFF
  border-radius 12px
  margin 0 auto 20px
  overflow hidden
</style>
